import { useState } from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp, Users } from 'lucide-react';
import { motion, AnimatePresence } from "framer-motion";
import LGASection from './LGASection';
import { useAuth } from '@/context/AuthContext';
import { generateReferralUrl } from '@/utils/referralUtils';

interface StateCardProps {
  state: string;
  isAdmin: boolean;
  isExpanded: boolean;
  onToggleExpand: (state: string) => void;
  ambassadorCount?: number;
}

const StateCard = ({ state, isAdmin, isExpanded, onToggleExpand, ambassadorCount = 0 }: StateCardProps) => {
  const { user } = useAuth();
  const referralUrl = user ? generateReferralUrl(user.id) : '';
  
  return (
    <motion.div layout="position">
      <Card className={`overflow-hidden ${isExpanded ? 'ring-2 ring-primary/20' : ''}`}>
        <CardContent className="p-0">
          <Button 
            variant="ghost" 
            className="w-full justify-between rounded-none h-auto py-3 px-4"
            onClick={() => onToggleExpand(state)}
          >
            <div className="flex items-center">
              <span className="font-medium">{state}</span>
              {ambassadorCount > 0 && (
                <div className="ml-2 flex items-center text-xs text-orange-600 bg-orange-50 rounded-full px-2 py-0.5">
                  <Users size={12} className="mr-1" /> 
                  {ambassadorCount}
                </div>
              )}
            </div>
            {isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
          </Button>
          
          <AnimatePresence>
            {isExpanded && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="overflow-hidden border-t"
              >
                <div className="p-4">
                  <LGASection 
                    state={state} 
                    isAdmin={isAdmin} 
                    userId={user?.id}
                    referralUrl={referralUrl}
                  />
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default StateCard;
